<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length > 2 ? "UPDATE" : "ADD NEW" }} PRODUCT</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
      <div v-if="Object.entries(this.data).length <= 2" class="vx-row w-full">
        <div class="vx-col w-full" style="font-size:90%">
          Product Category
          <v-select :options="data_options_product_category" @input="getProductList(); SetProductName()" v-model="dataProductCategoryId"/>
        </div>
        <div class="vx-col w-full" style="font-size:90%">
          <br/>Product
          <v-select :options="data_options_product" @input="getProductData(); SetProductName()" v-model="dataProductId"/>
        </div>
      </div>

    <br v-if="Object.entries(this.data).length <= 2"/>
        <hr v-if="Object.entries(this.data).length <= 2" class="mt-5 w-full">
        <div class="vx-row w-full">
          <div class="vx-col w-full">
              <vs-input label="Product" v-model="dataName"  class="mt-4 w-full" name="name" disabled/>
          </div>
          <div class="vx-col w-1/2">
            <vs-input label="Quantity" v-model="dataQuantity" @input="SetVolumeTotalAndPriceTotalLive" @change="SetVolumeTotalAndPriceTotal" class="mt-4 w-full" name="quantity"/>
          </div>
          <div class="vx-col w-1/2">
            <vs-input label="Unit of Measure" v-model="dataUom" class="mt-4 w-full" name="uom" disabled/>
          </div>
          <div class="vx-col w-1/2">
            <vs-input label="Unit Volume (m3)" v-model="dataVolume" class="mt-4 w-full" name="unitvolume" disabled />
          </div>
          <div class="vx-col w-1/2">
            <vs-input label="Volume Total (m3)" v-model="dataVolumeTotal" class="mt-4 w-full" name="volume" disabled />
          </div>
        </div>  
        <hr class="mt-5 w-full">
        <div class="vx-row w-full">
          <div class="vx-col w-1/2">
            <vs-input v-if="this.dataIdCategoryOperation === 2" label="Price/Unit (EUR)" v-model="dataUnitPrice" @input="SetVolumeTotalAndPriceTotalLive" @change="SetVolumeTotalAndPriceTotal" class="mt-4 w-full" name="unit price"/>
            <vs-input v-if="this.dataIdCategoryOperation === 1" label="Price/m3 (EUR)" v-model="dataUnitPrice" @input="SetVolumeTotalAndPriceTotalLive" @change="SetVolumeTotalAndPriceTotal" class="mt-4 w-full" name="unit price"/>
          </div>
          <div class="vx-col w-1/2">
            <vs-input label="Theoretical Price (EUR)" v-model="dataTheoreticalPrice" class="mt-4 w-full" name="theoretical price" disabled/>
          </div>
          <div class="vx-col w-full">
            <vs-input label="Total Price (EUR)" v-model="dataTotalPrice" v-validate="'required'" class="mt-4 w-full" name="price" disabled />
          </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>
 
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from '@/axios.js'
import moduleOperationList from '@/store/operation/moduleOperationList.js'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {  
      dataId: null,
      data_options_product_category: [],
      dataProductCategoryId: '',
      data_options_product: [],
      dataProductId: '',
      dataVolume: '',
      dataQuantity: '',
      dataVolumeTotal: '',
      dataTotalPrice: '',
      dataUom: '',
      dataUnitPrice: '',
      dataName: '',
      dataTheoreticalPrice: '',
      dataIdCategoryOperation:null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 2) { 
        this.initValues()
        this.$validator.reset()
        this.dataIdOperation = this.data.idoperation
        this.dataIdCategoryOperation = this.data.idcategoryoperation
      } else {
        this.dataIdCategoryOperation = this.data.idcategoryoperation
        this.dataIdOperation = this.data.operations_products.idoperation
        this.dataName = this.data.productcategory.name_en+" "+this.data.name
        this.dataQuantity = this.data.operations_products.quantity
        this.dataVolume = this.data.volume
        this.dataVolumeTotal = (this.data.volume * this.dataQuantity)
        this.dataUom = this.data.uomsreference.name_en
        this.dataTheoreticalPrice =  this.data.productcategory.price
        if (this.data.operations_products.unit_price) {
          this.dataUnitPrice = this.data.operations_products.unit_price
          if (this.dataIdCategoryOperation === 2) // SALE
          {
            this.dataTotalPrice = Math.abs(this.data.operations_products.unit_price) * Math.abs(this.dataQuantity)
          }
          else if (this.dataIdCategoryOperation === 1)
          {
            this.dataTotalPrice = (this.data.operations_products.unit_price * this.dataQuantity)
          }
        }
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && (this.dataProductId.value && this.dataQuantity) || (this.data.id && this.dataQuantity)
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
  },
  methods: {
    getProductCategoryList()
    {
      axios.get('/productcategory/active-combobox/data')
        .then((response) => {
          this.data_options_product_category = [...response.data]
        })
    },
    getProductList()
    {
      this.dataProductId = '',
      this.dataVolume = '',
      this.dataQuantity = '',
      this.dataUom = '',
      this.dataVolumeTotal = '',
      this.dataUnitPrice = '',
      this.dataTheoreticalPrice = '',
      this.dataTotalPrice = '',
      axios.get('/product/active-combobox/data/'+this.dataProductCategoryId.value)
          .then((response) => {
            this.data_options_product = [...response.data]
        })
    },
    getProductData()
    {
      axios.get('/product/data/'+this.dataProductId.value)
        .then((response) => {
          this.dataVolume = response.data.volume
          this.dataUom = response.data.uomsreference.name_en
          this.dataTheoreticalPrice = response.data.productcategory.price
        })
    },
    SetProductName()
    {
      this.dataName = (this.dataProductCategoryId.label + " " + this.dataProductId.label)
    },
    SetVolumeTotalAndPriceTotalLive()
    {
          this.dataVolumeTotal = (this.dataVolume * this.dataQuantity)
          this.dataTotalPrice = this.dataQuantity * this.dataUnitPrice
    },
    SetVolumeTotalAndPriceTotal()
    {
      if (this.dataIdCategoryOperation === 2) // SALE
      {

        this.dataQuantity = -(Math.abs(this.dataQuantity))
        this.dataVolumeTotal = (this.dataVolume * this.dataQuantity)
        this.dataTotalPrice = (Math.abs(this.dataQuantity) * Math.abs(this.dataUnitPrice))
      }
      else if (this.dataIdCategoryOperation === 1) // RECEPTION
      {
        this.dataQuantity = (Math.abs(this.dataQuantity))
        this.dataUnitPrice = -(Math.abs(this.dataUnitPrice))
        this.dataVolumeTotal = (this.dataVolume * this.dataQuantity)
        this.dataTotalPrice = (this.dataQuantity * this.dataUnitPrice)
      }
    },
    initValues () {
      if (this.data.id) return
        this.dataProductCategoryId = '',
        this.dataProductId = '',
        this.dataVolume = '',
        this.dataQuantity = '',
        this.dataUom = '',
        this.dataVolumeTotal = '',
        this.dataUnitPrice = '',
        this.dataTheoreticalPrice = '',
        this.dataTotalPrice = '',
        this.dataName = ''
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          var obj = {}
          var idoperation = null
          if (this.data.idoperation) idoperation = this.data.idoperation
          else idoperation = this.data.operations_products.idoperation

          if (this.dataProductId.value)
          {
            obj = {
              idoperation: idoperation,
              idproduct: this.dataProductId.value,
              quantity: this.dataQuantity,
              price: this.dataUnitPrice
            }
          }
          else {
              obj = {
              idoperation: idoperation,
              idproduct: this.data.id,
              quantity: this.dataQuantity,
              price: this.dataUnitPrice
            }
          }
          if (this.data.id !== null && this.data.id >= 0) {
            this.$store.dispatch('operationList/updateItem', obj)        
            .then(res => { 
              this.$vs.notify({
                color: 'success',
                title: 'Product Updated!',
                text: 'The product was successfully updated'
              }) 
              this.$emit('closeSidebar')
              this.initValues()
            })
            .catch(err => { 
              console.error(err) 
              this.$vs.notify({
                color: 'danger',
                title: 'You cannot add 2 times the same product!',
                text: 'The product was NOT updated' 
              })
            })
          }
          else {
            delete obj.id
            this.$store.dispatch('operationList/createItem', obj)        
            .then(res => { 
              this.$vs.notify({
                color: 'success',
                title: 'Product Created!',
                text: 'The product was successfully added'
              }) 
              this.$emit('closeSidebar')
              this.initValues()
            })
            .catch(err => { 
              console.error(err) 
              this.$vs.notify({
                color: 'danger',
                title: 'You cannot add 2 times the same product!',
                text: 'The product was NOT added' 
              })
            })
          }
        }
      })
    }   
  },
  created () {
    this.getProductCategoryList();
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
